/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-messaging-v2';

type Props = {
  /** Confirms the discard — closes the whole message modal, losing the draft. */
  onDiscard: () => void;
  /** Returns to the screen the admin was on before they tried to close. */
  onKeepEditing: () => void;
};

const styles = {
  actions: css`
    display: flex;
    align-items: center;
    gap: var(--cds-spacing-150);
    width: 100%;
  `,
};

/**
 * Confirmation screen shown when the admin tries to close the modal mid-draft.
 * The modal title becomes "Discard this message?"; this renders the warning and
 * the Discard / Keep editing actions. Lives in the same Dialog so only one
 * modal is ever visible.
 */
const DiscardScreen = ({ onDiscard, onKeepEditing }: Props) => (
  <React.Fragment>
    <Dialog.Content>
      <Typography2 component="p" variant="bodyPrimary">
        {_t("You'll lose all your progress.")}
      </Typography2>
    </Dialog.Content>
    <Dialog.Actions>
      <div css={styles.actions}>
        <Button variant="primary" onClick={onDiscard} data-testid="discard-message-confirm">
          {_t('Discard')}
        </Button>
        <Button variant="secondary" onClick={onKeepEditing} data-testid="discard-message-keep-editing">
          {_t('Keep editing')}
        </Button>
      </div>
    </Dialog.Actions>
  </React.Fragment>
);

export default DiscardScreen;
